import { ArrowHeadRightIcon, Checkbox, Chip, Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { lowercaseFirstLetter, naturalStringSort } from 'utils/stringHelper';
import styles from './_PlanungImportForms.module.scss';

type PlanungImportTeachersFormRowProps = {
  uuid: string;
  selected: boolean;
  name: string;
  profiles: { uuid: string; name: string }[];
  selectedProfile: { value: string; label: string } | null;
  connected: boolean;
  onSelect: (isSelected: boolean) => void;
  onProfileSelect: (uuid: string | null) => void;
};

export const PlanungImportTeachersFormRow = ({
  uuid,
  selected,
  name,
  profiles,
  connected,
  selectedProfile,
  onSelect,
  onProfileSelect,
}: PlanungImportTeachersFormRowProps) => {
  const { t } = useTranslation();

  const profileOptions: SelectOptionType[] = profiles
    .map((p) => ({ value: p.uuid, label: p.name }))
    .sort((a, b) => naturalStringSort(a.label, b.label));

  return (
    <div className={classNames(styles['form-row'], styles.teachers, { [styles.selected]: selected })}>
      <div>
        <Checkbox
          onChange={(event) => {
            onSelect(event.target.checked);
          }}
          checked={selected}
          name={`check-${uuid}`}
          label={name}
          preventLabelWrapping
        />
      </div>
      <div>
        <ArrowHeadRightIcon />
      </div>
      <div>
        <Select
          dense
          options={profileOptions}
          name={`select-profile-${uuid}`}
          placeholder={selected ? lowercaseFirstLetter(t('planungImport.willBeCreated')) : undefined}
          onChange={(event) => {
            const selectOption = event as SelectOptionType;
            const uuid = selectOption ? (selectOption.value as string) : null;
            onProfileSelect(uuid);
          }}
          value={selectedProfile}
          isClearable
          isSearchable
          menuPosition='fixed'
          disabled={!selected}
        />
      </div>
      <div>
        <Chip
          isSmall
          value={connected ? <>&#10003;</> : <>&#8212;</>}
          color={connected ? 'var(--color-white)' : 'var(--color-grey-light)'}
          bgColor={connected ? 'var(--color-primary)' : 'var(--color-grey-lighter)'}
        />
      </div>
    </div>
  );
};
